export default {
  short_description: 'Economisește timp și câștigă recompense!',
  full_description:
    'Aplicația {{name}} este aici – pentru o comandă și mai ușoară:\n\n• Comandă super rapid prin aplicație\n\n• Notificări imediate despre promoții și recompense\n\n• Colectează și răscumpără punctele cu ușurință\n\n• Urmărește starea comenzii în timp real\n\nSuntem bucuroși să îți oferim aplicația noastră – și sperăm să te bucuri de ea la fel de mult ca noi!`',
};
